import da from "element-ui/src/locale/lang/da";

let state = {
    user: '',
}

let getters = {
}

let actions = {

}

let mutations = {
    UpUser(state, data) {
        state.user = data
        //this.$store.commit('user/UpUser', item)
        //this.$store.state.user.user
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}